import React from 'react';

const ModalFooter = ({ children }) => (
  <footer className="flex flex-row-reverse m-5 flex-grow-0">{children}</footer>
);

export default ModalFooter;
